// GlassSheet — modals / bottom sheets / dialogs. Most opaque surface + grabber.
import React from 'react';
import { View, StyleSheet } from 'react-native';
import GlassSurface, { GlassSurfaceProps } from './GlassSurface';
import { glassTokens } from './tokens';
import { spacing } from '../../constants/theme';

export interface GlassSheetProps extends GlassSurfaceProps {
  padding?: number;
  grabber?: boolean;
}

export default function GlassSheet({
  radius = glassTokens.radius.xl,
  padding = spacing.xl,
  grabber = true,
  contentStyle,
  children,
  ...rest
}: GlassSheetProps) {
  return (
    <GlassSurface variant="sheet" radius={radius} contentStyle={[{ padding }, contentStyle]} {...rest}>
      {grabber && <View style={styles.grabber} />}
      {children}
    </GlassSurface>
  );
}

const styles = StyleSheet.create({
  grabber: {
    alignSelf: 'center',
    width: 40,
    height: 4,
    borderRadius: 2,
    backgroundColor: 'rgba(26,26,46,0.18)',
    marginBottom: spacing.md,
  },
});
